<template>
	<div class="flex xs-12 p4">
		<beneficiaries
			class="mt4 xs-12"
			:caseId="caseId"
			:insuredId="insuredId"
			:list="computedBeneficiaries"
			@added="fetchCase"
			@removed="fetchCase"
		/>
	</div>
</template>

<script>
import Beneficiaries from "./Beneficiaries"

export default {
	components: {
		Beneficiaries
	},

	computed: {
		computedBeneficiaries() {
			return this.$store.state.caseManagement?.case?.beneficiaryEligibilities
		},
		caseId() {
			return this.$store.state.caseManagement.caseId
		},
		insuredId() {
			return this.$store.state.caseManagement?.case?.insureds?.[0]?.id
		}
	},

	methods: {
		fetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		}
	}
}
</script>
